<template id="updating_metricspage">
    <section>

        <div v-for="r of rows" v-bind:key="r" ref="childComponent">
                <updating_metrics :updating_metrics="vizDataRowCol[screenlet][r]"></updating_metrics>
            </div>

    </section>
</template>
<script>
import updating_metrics from '@/components/updating_metrics'
import _ from 'lodash'

export default {
        name: "updating_metricspage",
        components: {updating_metrics},
        data: () => ({
            searching: false,
            vizData: [],
            vizDataRowCol: {},
            rows: [],
            rowColMap: {},
          screenlet:1
        }),
        computed: {},
        created() {
            this.loadSummary()
            this.listenToRouter()
        },
        methods: {
            makeWidth: function (r, c) {
                let v0 = this.vizDataRowCol[r][c][0].vizunitWidthArray
                console.log("Viz unit Width Array", v0);
                let defV = ['2', '4', '5']
                let v = v0 && v0.length > 0 ? v0 : defV
                //let lg = v[2], md = v[1], sm = v[0]
                //return `col-lg-${lg} col-md-${md} col-sm-${sm}`
                let lg = v[2]
                //what's the parent width..
                let w = ""
                let isMobile = window.innerWidth < 400
                if (isMobile) w = `width: 100%`
                else w = `width: ${lg * 10 - 5}%`
                console.log("isMobile?", isMobile, window.innerWidth, lg, w);
                return w
            },
            loadSummary: function () {
                console.info('loading summary')
                let menuParam = this.$route.params.menuId
                let submenuParam = this.$route.params.submenuId
                this.$store.dispatch("loadState").then(() => {
                    //let allVizData = this.$store.state.fwScreenConfig
                    let allVizData = this.$store.state.fwConfigScreenElement
                    console.log("Visualization Data", allVizData)

                    //let vizData = allVizData.filter(r => r.menuId === menuParam && r.subMenuId === submenuParam)
                    if(this.screenletId){
                      this.vizDataRowCol[this.screenlet] = allVizData.filter(r => r.menuId === submenuParam && r.screenletInstanceId===this.screenletId)
                    }
                    else{
                      this.vizDataRowCol[this.screenlet] = allVizData.filter(r => r.menuId === submenuParam)
                    }


                    if (this.vizDataRowCol[this.screenlet].length === 0) {
                        console.error("No vizdata for the screen, hence Blank Screen..fix data",  this.vizDataRowCol[this.screenlet].length)
                        return
                    }
                    // console.log('Testing Passed Parameter for selecttttt', x)  //for passing paramter
                    /*this.$nextTick(() => {
                        bus.$emit('test', x)
                    });
*/
                    // let menuParam = this.$route.params.menuId
                    // let submenuParam = this.$route.params.submenuId
                    console.info('loading summary')
                    this.menuName = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam).map(m => m.menuName)[0]
                    this.menusyspk = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam).map(m => m.syspk)[0]


                    console.log("Menu NAme", this.menuName);
                    console.log("Screen NAme", this.screenName,this.menusyspk);
                    //this.vizDataRowCol[this.screenlet] = _.clone(vizData)

                    // this.$store.commit('setLBwhereCond',{k:this.screenlet, v:_.extend({}, x, this.sl)})
                    //console.log("the store value",this.$store.state.lbWhereCond[this.screenlet],this.screenlet)
                    /*for (var i = 0; i < this.vizDataRowCol[this.screenlet].length; i++) {

                        this.vizDataRowCol[this.screenlet][i]['f'] = _.extend({},x,this.sl)
                        //vizData[i]['f2'] = y //work around
                        //vizData[i]['f'][Object.keys(y)] =y[Object.keys(y)]
                        this.vizDataRowCol[this.screenlet][i]['f']['fromDate'] = [this.time3[0]]
                        this.vizDataRowCol[this.screenlet][i]['f']['toDate'] = [this.time3[1]]
                        this.vizDataRowCol[this.screenlet][i]['fromDate'] = this.time3[0] //work around
                        this.vizDataRowCol[this.screenlet][i]['toDate'] = this.time3[1] //work around

                    }
                    console.log("Passed x value",x,this.screenlet,_.clone(x))*/
                    console.log("After appending LB",this.screenlet);
                    //what we'll do is identify the max rows
                    //then for each row identify the max cols
                    //let maxRows = _.max(vizData.map(v => v.positionRow)) + 1
                    let maxRows = this.vizDataRowCol[this.screenlet].length
                    console.log("Max Rows", maxRows);
                    //this.rows = _.range(1, maxRows)
                    this.rows = _.range(0, maxRows)
                    // let kk = this.screenlet
                    //this.vizDataRowCol = _.clone(vizData)
                    console.log("VizDataRowCol", this.screenlet,this.vizDataRowCol[this.screenlet][0].f,this.vizDataRowCol)
                    //log the event in audi log
                    // commenting to neglect
                   this.$commonFn.auditLog(this.menusyspk, submenuParam, this.menuName, this.screenName, "GET", "Success")
                   // this.$commonFn.auditLog(this.menusyspk,"",this.menuName, this.screenName, "", "GET", "Success")
                    //this.$refs.childComponent.loadViz()
                    // let dateFilter = {"d4l1_date": this.time3[0]}
                    // console.log("Date time range selection", this.time3, dateFilter);
                }, err => {
                    console.error("error in getting he viz1 data", err)
                })
            },
            listenToRouter: function () {
                let $this = this
                this.$router.afterEach(function (from, to) {
                    console.log(`router moved to ${from.path} from ${to.path}, updating_metricspage updating_metrics = ${$this.rows.length}`)
                    $this.rows = []
                    setTimeout(() => {
                        $this.loadSummary()
                    }, 300)

                })
            }
        }
    }
</script>